module.exports = __webpack_public_path__ + "img/partners-icon9.bd91bd54.jpg";